/**
 * Testimonials Data
 *
 * Mock data for testimonials section on Landing Page
 * Easy to modify and extend
 */

export interface Testimonial {
  id: string;
  name: string;
  role: string;
  location: string;
  age: number;
  content: string;
  usedSince: string; // e.g., "6 tháng trước"
  rating: number; // 1-5
  icon: 'family_restroom' | 'school' | 'person';
  colorTheme: 'yellow' | 'orange' | 'amber';
}

export const TESTIMONIALS: Testimonial[] = [
  {
    id: 'parent-1',
    name: 'Chị Nguyễn Thị Lan',
    role: 'Phụ huynh học sinh',
    location: 'Hà Nội',
    age: 42,
    content: `Trước đây, tôi luôn nghĩ con mình có tính cách giống mình, nên thường không hài lòng khi thấy con thực hiện công việc không theo cách tôi mong đợi. Tôi cho rằng con chưa cố gắng đủ hoặc làm chưa đúng.

Cho đến một lần tình cờ, tôi làm bài Hướng Nghiệp CAT và so sánh kết quả của mình với kết quả của con. Lúc đó tôi thực sự bất ngờ khi nhận ra tính cách, cách suy nghĩ và động lực của con hoàn toàn khác tôi.

Nhờ Hướng Nghiệp CAT, tôi học được cách nhìn con bằng sự thấu hiểu thay vì áp đặt. Tôi biết cách hỗ trợ và định hướng cho con phát triển đúng với tính cách và thế mạnh riêng của con. Từ đó, mối quan hệ giữa hai mẹ con trở nên nhẹ nhàng hơn và con cũng tự tin, tiến bộ rõ rệt.`,
    usedSince: '6 tháng trước',
    rating: 5,
    icon: 'family_restroom',
    colorTheme: 'yellow',
  },
  {
    id: 'student-1',
    name: 'Bạn Trần Minh Đức',
    role: 'Sinh viên đại học',
    location: 'TP. Hồ Chí Minh',
    age: 21,
    content: `Hai năm đầu đại học với mình thực sự là quãng thời gian rất chật vật. Mình học mãi không vào, càng cố gắng càng mệt mỏi và luôn tự hỏi liệu bản thân có "kém cỏi" hay không khi thấy các môn học ngày càng trở thành áp lực.

Trong một lần tình cờ, mình làm bài Hướng Nghiệp CAT và lần đầu tiên hiểu rõ tính cách, cách học và cách làm việc phù hợp với bản thân. Kết quả cho thấy tính cách của mình gần như không phù hợp với ngành đang theo học, nhưng lại rất phù hợp với một số ngành tương đương khác mà trước đây mình chưa từng nghĩ tới.

Nhờ đó, mình kịp thời điều chỉnh định hướng ở giai đoạn 2 của chương trình đại học. Việc học trở nên nhẹ nhàng hơn rất nhiều và mình cảm thấy có động lực rõ ràng. Sau khi ra trường, mình đã tìm được công việc phù hợp với tính cách và năng lực của mình hơn.

**Hướng Nghiệp CAT giúp mình hiểu rằng: không phải mình kém, mà chỉ là mình đang đi sai hướng.**`,
    usedSince: '1 năm trước',
    rating: 5,
    icon: 'school',
    colorTheme: 'orange',
  },
  {
    id: 'teacher-1',
    name: 'Thầy Phạm Văn Hùng',
    role: 'Giáo viên THPT',
    location: 'Hà Nội',
    age: 38,
    content: `Trong quá trình giảng dạy và tư vấn, tôi thường xuyên gặp nhiều phụ huynh và học sinh tìm đến để xin lời khuyên về định hướng nghề nghiệp. Tuy nhiên, mỗi học sinh lại có năng lực, tính cách và mong muốn rất khác nhau. Bên cạnh đó, không phải lúc nào thầy cô cũng có thể cập nhật đầy đủ và chính xác 100% về thị trường lao động đang thay đổi từng ngày.

Từ khi sử dụng Hướng Nghiệp CAT, tôi cảm thấy tự tin hơn rất nhiều trong vai trò tư vấn hướng nghiệp. CAT cung cấp một công cụ khoa học, có hệ thống, giúp thầy cô hiểu rõ hơn về tính cách, điểm mạnh và sự phù hợp nghề nghiệp của từng học sinh.

Nhờ đó, việc tư vấn không còn dựa nhiều vào cảm tính hay kinh nghiệm cá nhân, mà có cơ sở rõ ràng để đồng hành cùng học sinh và phụ huynh trong việc lựa chọn hướng đi phù hợp và bền vững hơn cho tương lai.`,
    usedSince: '1 tháng trước',
    rating: 5,
    icon: 'person',
    colorTheme: 'amber',
  },
];
